/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Space,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const TimeOfClickModal = (props: {
  isVisible: boolean;
  onClose: () => void;
  saveConfig: () => void;
}) => {
  const { isVisible, onClose, saveConfig } = props;
  const { t } = useTranslation();
  // local state
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const onSave = React.useCallback(() => {
    saveConfig();
    onClose();
  }, []);

  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={isVisible}
      onClose={onClose}
      size="lg"
    >
      <ModalOverlay opacity={0.9} />
      <ModalContent backgroundColor={colorStyle.background.secondary}>
        <ModalBody ml="24px" mt="16px" mb="16px">
          <Flex direction="column">
            <Text>{t('policy.timeOfClickProtection.warmMessage')}</Text>
          </Flex>
          <Flex pt="48px">
            <Text>{t('common.label.dangerMessage')}</Text>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" minWidth="20x" onClick={onSave}>
            {t('common.button.save')}
          </Button>
          <Space width="2x" />
          <Button minWidth="20x" onClick={onClose}>
            {t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default React.memo(TimeOfClickModal);
